import {StoreShelfStylesDto} from "../../dtos";
import {Action} from "../actions/storeShelfStylesActions";
import {ActionType} from "../actionTypes";

export interface SaleTypes {
    saleTypes: any;
    saleTypesForSpecificFlyer: any;
    sellingUnits: any;
}



const initialState: StoreShelfStylesDto = {
    storeShelfStyles: []
};

const storeShelfStylesReducer = (state: StoreShelfStylesDto = initialState, action: Action) => {

    switch(action.type)
    {
        case ActionType.SET_STORE_SHELF_STYLES:
            return { ...state, storeShelfStyles: action.payload };
        default:
            return state;
    }
}

export default storeShelfStylesReducer;
